'use client';

import { Button } from '@common/components';
import { SvgRefresh } from '@common/icon';
import { useEffect } from 'react';

import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
import { BREAKPOINTS } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';

interface FilterDrawerShellProps {
  isOpen: boolean;
  onReset: () => void;
  onApply: () => void;
  onClose: () => void;
  children: React.ReactNode;
}

export function FilterDrawerShell({
  isOpen,
  onReset,
  onApply,
  onClose,
  children,
}: FilterDrawerShellProps) {
  const isDesktop = useMediaQuery(BREAKPOINTS.DESKTOP, true);

  useEffect(() => {
    if (isDesktop && isOpen) onClose();
  }, [isDesktop, isOpen, onClose]);

  if (isDesktop) return null;

  return (
    <ResponsiveDialog opened={isOpen} onClose={onClose} drawerType="bottom">
      <div className="flex flex-col gap-24 pb-32">
        <div className="flex justify-end">
          <Button
            type="button"
            theme="sub-text"
            dimensions="H32"
            className="gap-4 p-0 font-700 text-Gray-600 typo-body4"
            onClick={onReset}
          >
            <SvgRefresh className="size-14" />
            초기화
          </Button>
        </div>
        {children}
        <Button
          theme="primary-fill"
          dimensions="H56"
          className="w-full"
          onClick={onApply}
        >
          적용 할게요
        </Button>
      </div>
    </ResponsiveDialog>
  );
}
